export class StopBindingBindingHandler implements KnockoutBindingHandler {
    constructor() {
        ko.virtualElements.allowedBindings.stopBinding = true;
    }

    init() {
        return { 'controlsDescendantBindings': true };
    }
}
